import React from 'react';
import { ErrorPage, Title } from './Styles'

const PageNotFound = () => (
    <ErrorPage>
        <Title>Page not found!</Title>
        <p><a href='/dashboard'>Return Home</a></p>
    </ErrorPage>
)

export default PageNotFound;